import { FC } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  IconButton,
  Typography,
  Divider,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import { IProjectUI } from 'data/types/project.types';
import ManageProjectMembersList from './ManageProjectMembersList';
import AddProjectMember from './AddProjectMember';

type TManageProjectMemberModalProps = {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  currentMembers: IProjectUI['members'];
  projectId: string;
  projectName: string;
};

const ManageProjectMemberModal: FC<TManageProjectMemberModalProps> = ({
  open,
  setOpen,
  currentMembers,
  projectId,
  projectName,
}) => {
  const handleCloseModal = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleCloseModal}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          maxHeight: '80vh',
        },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          pb: 1,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: 2,
              backgroundColor: 'primary.main',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <PeopleOutlineIcon sx={{ color: 'white', fontSize: 22 }} />
          </Box>
          <Box>
            <Typography variant="h6" component="span" sx={{ fontWeight: 600 }}>
              Manage people
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              {projectName}
            </Typography>
          </Box>
        </Box>
        <IconButton onClick={handleCloseModal} size="small">
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ pt: 2 }}>
        {/* Current Members Section */}
        <Box sx={{ mb: 3 }}>
          <Typography
            variant="subtitle2"
            sx={{
              color: 'text.secondary',
              fontWeight: 600,
              mb: 2,
              textTransform: 'uppercase',
              fontSize: '0.75rem',
              letterSpacing: '0.5px',
            }}
          >
            Project members ({currentMembers.length})
          </Typography>
          <ManageProjectMembersList
            projectId={projectId}
            members={currentMembers}
            projectName={projectName}
          />
        </Box>

        <Divider sx={{ my: 3 }} />

        {/* Add People Section */}
        <Box>
          <Typography
            variant="subtitle2"
            sx={{
              color: 'text.secondary',
              fontWeight: 600,
              mb: 2,
              textTransform: 'uppercase',
              fontSize: '0.75rem',
              letterSpacing: '0.5px',
            }}
          >
            Add people
          </Typography>
          <AddProjectMember
            currentMembers={currentMembers}
            projectId={projectId}
            projectName={projectName}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ManageProjectMemberModal;
